import { render, staticRenderFns } from "./IntegrationModalBody.vue?vue&type=template&id=cfa32fd4&scoped=true&"
import script from "./IntegrationModalBody.vue?vue&type=script&lang=js&"
export * from "./IntegrationModalBody.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationModalBody.vue?vue&type=style&index=0&id=cfa32fd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa32fd4",
  null
  
)

export default component.exports